module.exports = __webpack_public_path__ + "static/1-4677e69efff05bfc1b0f24e49385e382.jpg";